import * as React from 'react';

type IconInformeLegalProps = React.SVGProps<SVGSVGElement>;

export const IconInformeLegal: React.FC<IconInformeLegalProps> = (props) => (
	<svg
		width={29}
		height={34}
		viewBox="0 0 29 34"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			width="4.54395"
			height="17.0398"
			rx="2.15837"
			transform="matrix(0.70711 -0.707103 0.70711 0.707103 13.5588 17.1663)"
			fill="#7EAE90"
		/>
		<path
			d="M5.80168 17.1625C4.02715 15.388 4.02715 12.5109 5.80168 10.7364L10.6213 5.91687C12.3958 4.14236 15.2729 4.14236 17.0474 5.91687L19.4572 8.32665C21.2318 10.1012 21.2318 12.9782 19.4572 14.7527L14.6376 19.5723C12.8631 21.3468 9.98601 21.3468 8.21148 19.5723L5.80168 17.1625Z"
			fill="#EBF8F0"
		/>
		<rect
			width="4.54395"
			height="12.4958"
			rx="1.0234"
			transform="matrix(0.70711 -0.707103 0.70711 0.707103 13.031 3.50806)"
			fill="#FFA692"
		/>
		<rect
			width="4.54395"
			height="12.4958"
			rx="1.0234"
			transform="matrix(0.70711 -0.707103 0.70711 0.707103 0.17894 16.3596)"
			fill="#FFA692"
		/>
		<rect
			x="0.547592"
			y="30.2971"
			width="15.9039"
			height="3.40794"
			rx="1.70397"
			fill="#7EAE90"
		/>
		<path
			d="M2.81908 30.2956C2.81908 29.0409 3.83627 28.0237 5.09104 28.0237H11.907C13.1618 28.0237 14.179 29.0409 14.179 30.2956H2.81908Z"
			fill="#7EAE90"
		/>
	</svg>
);
